export default __webpack_public_path__ + "static/media/icon-ic-google.d51f3bb8.svg";